export default __webpack_public_path__ + "static/media/bg1.410c0006.jpeg";